import "./SewerCameraInspection.module.css";
import Header from "@/reusable_sections/Header";
import SellYourMotorcycleFastAndSafe from "./sections/SellYourMotorcycleFastAndSafe";
import UniversityOverview from "./sections/UniversityOverview";
import WhyWartmannUmzuege from "./sections/WhyWartmannUmzuege";
import FinalCallToAction from "./sections/FinalCallToAction";
import Footer from "@/reusable_sections/Footer";
export default function SewerCameraInspectionPage() {
  return <div>
      <Header />
      <SellYourMotorcycleFastAndSafe />
      <UniversityOverview />
      <WhyWartmannUmzuege />
      <FinalCallToAction />
      <Footer />
    </div>;
}